import ChatFilesForm from './ChatFilesForm';

export default ChatFilesForm;
